
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
  },
};
